import apiClient from "./index";

export const getAdminStoreId = async (accountId) => {
  try {
    const response = await apiClient.get(`/admins/store/${accountId}`);
    console.log("✅ 관리자 및 스토어 정보 응답:", response.data);

    // store_id가 0이거나 undefined일 경우만 에러 처리
    if (!response.data || response.data.store_id == null) {
      console.warn("⚠️ 관리자에게 할당된 스토어가 없음:", response.data);
      return null; // `null`을 반환하여 처리
    }

    return response.data; // { admin_id, store_id }
  } catch (error) {
    console.error("❌ 관리자 및 스토어 정보 조회 실패:", error);
    return null; // ❌ `throw` 하지 않고 `null` 반환
  }
};

export const submitTransaction = async (transactionData) => {
  console.log("🛠 결제 데이터 전송 시작:", transactionData);
  try {
    const response = await apiClient.post("/transactions", transactionData);
    console.log("✅ 결제 성공:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ 결제 요청 실패:", error.response?.data || error.message);
    throw error;
  }
};

// 한 번에 받아오는 건수. 서버 상한과 같은 값이어야 "더 있는지" 판정이 맞는다.
// (백엔드 routes/transactions.js 의 MAX_PAGE_SIZE 와 일치시킬 것)
export const SALES_PAGE_SIZE = 2000;

// ✅ 특정 관리자의 결제 내역 조회 (range: { from, to } — KST YYYY-MM-DD, 생략 시 서버가 최근 30일 적용)
// 받은 건수가 SALES_PAGE_SIZE 와 같으면 뒤에 더 있다는 뜻이라 hasMore 로 알린다.
export const fetchAdminSales = async (admin_id, range, offset = 0) => {
  try {
    const params = { limit: SALES_PAGE_SIZE, offset };
    if (range?.from && range?.to) {
      params.from = range.from;
      params.to = range.to;
    }
    const response = await apiClient.get(`/transactions/sales/${admin_id}`, { params });
    const rows = response.data || [];
    return { rows, hasMore: rows.length === SALES_PAGE_SIZE, failed: false };
  } catch (error) {
    // 실패와 "더 없음"을 같은 값으로 돌려주면, 통신이 끊겼을 때 잘린 목록이
    // 전체인 것처럼 보인다. 호출부가 구분할 수 있게 failed를 함께 준다.
    console.error("❌ 매출 내역 조회 실패:", error);
    return { rows: [], hasMore: false, failed: true };
  }
};

// ✅ 특정 관리자의 매출 집계 조회 (결제수단별/기간별/상품 랭킹 — 전체 기간 기준)
export const fetchSalesSummary = async (admin_id) => {
  try {
    const response = await apiClient.get(`/transactions/sales/${admin_id}/summary`);
    return response.data;
  } catch (error) {
    console.error("❌ 매출 집계 조회 실패:", error);
    return null;
  }
};